export const QUERY_KEY_ASSIGNMENT = 'assignment'
export const QUERY_KEY_NPS = 'nps'
export const QUERY_KEY_ASSIGNMENT_FOR_EMAILS = 'assignment_for_email'
export const QUERY_KEY_SCHEDULE = 'schedule'
export const QUERY_KEY_BRANCHES = 'branches'
export const QUERY_KEY_DIALPAD_STATS = 'dialpad-stats'
export const QUERY_KEY_DRIVER_SAFETY_SCORES = 'driver-safety-scores'
export const QUERY_KEY_SAFETY_EVENTS = 'safety-events'
export const MUTATE_KEY_CREATE_NOTIFICATION_RULE = 'createNotificationRule'
export const MUTATE_KEY_DELETE_NOTIFICATION_RULE = 'deleteNotificationRule'
export const MUTATE_KEY_FIRE_NOTIFICATION_RULE = 'fireNotificationRule'
export const QUERY_KEY_NOTIFICATION_RULES = 'notification_rules'
export const MUTATE_KEY_UPDATE_NOTIFICATION_RULE = 'updateNotificationRule'
export const QUERY_KEY_CONTRACT_EFFICIENCY = 'contract_efficiency'
export const MUTATE_KEY_UPDATE_CONTRACT_EFFICIENCY = 'updateContractEfficiency'
export const QUERY_KEY_REVIEWS = 'reviews'
export const MUTATE_KEY_DELETE_REVIEW = 'deleteReview'
export const MUTATE_KEY_CREATE_REVIEW = 'createReview'
export const MUTATE_KEY_UPDATE_REVIEW = 'updateReview'
export const MUTATE_KEY_SYNC_REVIEWS_FULL = 'syncReviewsFull'
export const MUTATE_KEY_SYNC_DAMAGES_FULL = 'syncDamagesFull'
export const QUERY_KEY_RIPPLING_WORK_HOURS = 'rippling-work-hours'
export const QUERY_KEY_DRIVER_SCORE = 'driver-score'
export const QUERY_KEY_ONSITE_EVAL = 'onsite-eval'
export const QUERY_KEY_PRAISE = 'praise'
export const QUERY_KEY_TRIP_TRACKER = 'trip-tracker'
export const QUERY_KEY_EINSTEIN_GAMES = 'einstein-games'
export const QUERY_KEY_EINSTEIN_GAMES_SNAPSHOT_BREAKDOWNS = 'einstein-games-snapshot-breakdowns'
export const QUERY_KEY_SNAPSHOT_NOTES = 'snapshot-notes'
export const QUERY_KEY_MOVER_GAMES = 'mover-games'
export const QUERY_KEY_DAMAGES = 'damages'
export const MUTATE_KEY_UPDATE_DAMAGE = 'updateDamage'
export const MUTATE_KEY_CREATE_DAMAGE = 'createDamage'
export const MUTATE_KEY_DELETE_DAMAGE = 'deleteDamage'
export const QUERY_KEY_CONSTANT = 'constant'
export const QUERY_KEY_ZIP_ZONES_BY_BRANCH_ID = 'zip_zones_by_branch_id'
export const QUERY_KEY_ZIP_ZONES_BY_BRANCH_BY_CODE = 'zip_zones_by_branch_by_code'
export const MUTATE_KEY_GET_ZIP_ZONES_BY_BRANCH_BY_CODE = 'get_zip_zones_by_branch_by_code'
export const QUERY_KEY_ZIP_ZONES_BY_BRANCH_BY_CODES = 'zip_zones_by_branch_by_codes'
export const MUTATE_KEY_GET_ZIP_ZONES_BY_BRANCH_BY_CODES = 'get_zip_zones_by_branch_by_codes'
export const QUERY_KEY_CHANNELS = 'channels'
export const QUERY_KEY_CUSTOMER = 'customer'
export const QUERY_KEY_CUSTOMERS = 'customers'
export const QUERY_KEY_EMPLOYEE = 'employee'
export const QUERY_KEY_EMAIL_TEMPLATE = 'email_template'
export const QUERY_KEY_EMAIL_TEMPLATES = 'email_templates'
export const QUERY_KEY_EMPLOYEES = 'employees'
export const QUERY_KEY_EMPLOYEES_ACTIVE = 'employees_active'
export const QUERY_KEY_MANAGER_BY_DAY_VIEW = 'manager_by_day_view'
export const QUERY_KEY_MANAGERS = 'managers'
export const QUERY_KEY_MOVERS = 'movers'
export const QUERY_KEY_MARKETING_SOURCES = 'marketing_sources'
export const QUERY_KEY_REPORT_SALE_DATA = 'report_sale_data'
export const QUERY_KEY_REPORT_SALE_DATA_SCORE_PAGE = 'report_sale_data_score_page'
export const QUERY_KEY_MOVE_REPORTS = 'move_reports'
export const QUERY_KEY_MOVER_ATTENDANCE = 'mover_attendance'
export const QUERY_KEY_MOVER_ATTENDANCE_REPORT = 'mover_attendance_report'
export const QUERY_KEY_MOVE_REVIEWS_REPORT = 'move_reviews_eg_report'
export const QUERY_KEY_MOVE_REVIEWS = 'move_reviews'
export const QUERY_KEY_DAMAGE_REPORT = 'damage_report'
export const QUERY_KEY_PERFORMANCE_LOGS = 'performance_logs'
export const QUERY_KEY_ECP_FEEDBACKS = 'ecp_feedbacks'
export const QUERY_KEY_REPORT_CHART_DATA = 'report_chart_data'
export const QUERY_KEY_TRUCK = 'truck'
export const QUERY_KEY_TRUCKS = 'trucks'
export const QUERY_KEY_TRUCKS_BY_DAY = 'trucks_by_day'
export const QUERY_KEY_UNAVAILABLE_TRUCK_BY_DAY = 'unavailable_truck_by_day'
export const QUERY_KEY_WORK_DAY_TRUCKS_CONFIRMED = 'work_day_trucks_confirmed'
export const QUERY_KEY_UNASSIGNED_MOVES_BY_DAY = 'unassigned_moves_by_day'
export const QUERY_KEY_CONTRACT_HISTORY = 'contract_history'
export const QUERY_KEY_CUSTOMER_NEW_LEADS = 'customer_new_leads'
export const QUERY_KEY_CUSTOMER_NEW_LEADS_TRIAGE = 'customer_new_leads_triage'
export const QUERY_KEY_CUSTOMER_NEW_LEADS_PAGINATED = 'customer_new_leads_paginated'
export const QUERY_KEY_CUSTOMER_AUTO_BOOKINGS = 'customer_auto_bookings'
export const QUERY_KEY_CUSTOMER_AUTO_BOOKINGS_CONSTANTS = 'customer_auto_bookings_constants'
export const MUTATE_KEY_UPDATE_MOVER_ASSIGNMENT = 'updateMoverAssignment'
export const MUTATE_KEY_UPDATE_ON_CALL_ASSIGNMENT = 'updateOnCallAssignment'
export const MUTATE_KEY_DELETE_MOVER_ASSIGNMENT = 'deleteMoverAssignment'
export const MUTATE_KEY_UPDATE_ASSIGNMENT_OPERATION = 'updateAssignmentOperation'
export const MUTATE_KEY_DELETE_ASSIGNMENT_OPERATION = 'deleteAssignmentOperation'
export const MUTATE_KEY_CREATE_UNAVAILABLE_TRUCKS = 'createUnavailableTrucks'
export const MUTATE_KEY_UPDATE_UNAVAILABLE_TRUCKS = 'updateUnavailableTrucks'
export const MUTATE_KEY_DELETE_UNAVAILABLE_TRUCKS = 'deleteUnavailableTrucks'
export const MUTATE_KEY_DELETE_TRUCK = 'deleteTruck'
export const MUTATE_KEY_DELETE_MULTIPLE_NOTE = 'deleteMultipleNote'
export const MUTATE_KEY_CREATE_MULTIPLE_NOTE = 'createMultipleNote'
export const MUTATE_KEY_UPDATE_ASSIGNMENT = 'updateAssignment'
export const MUTATE_KEY_DELETE_CUSTOMER_ACTIVITY = 'deleteCustomerActivity'
export const MUTATE_KEY_DELETE_CUSTOMER = 'deleteCustomer'
export const MUTATE_KEY_UPDATE_CUSTOMER_INACTIVE = 'updateCustomerInactive'
export const MUTATE_KEY_UPDATE_CUSTOMER_REACTIVATE = 'updateCustomerReactivate'
export const MUTATE_KEY_ADD_ACTIVITY_CUSTOMER = 'addActivityCustomer'
export const MUTATE_KEY_UPDATE_CUSTOMER = 'updateCustomer'
export const MUTATE_KEY_CLONE_CUSTOMER = 'cloneCustomer'
export const MUTATE_KEY_UPDATE_CONTRACT = 'updateContract'
export const QUERY_KEY_TROUBLE_LOCATIONS = 'trouble_locations'
export const MUTATE_KEY_UPDATE_TROUBLE_LOCATION = 'updateTroubleLocation'
export const MUTATE_KEY_CREATE_TROUBLE_LOCATION = 'createTroubleLocation'
export const MUTATE_KEY_CREATE_CUSTOMER = 'createCustomer'
export const QUERY_KEY_BRANCH = 'branch'
export const MUTATE_KEY_UPDATE_BRANCH = 'updateBranch'
export const MUTATE_KEY_CREATE_BRANCH = 'createBranch'
export const QUERY_KEY_TIMEZONE = 'timezone'
export const QUERY_KEY_REGION = 'region'
export const QUERY_KEY_CUSTOMER_BY_EMAIL = 'customer_by_email'
export const QUERY_KEY_CUSTOMER_BY_BRANCH_ID = 'customer_by_branch_id'
export const QUERY_KEY_NEW_LEADS_QUEUE_SIZE = 'new_leads_queue_size'
export const MUTATE_KEY_DELETE_TROUBLE_LOCATION = 'deleteTroubleLocation'
export const QUERY_KEY_AUTO_BOOKINGS_QUEUE_SIZE = 'auto_bookings_queue_size'
export const QUERY_KEY_EMAIL_PRICE_SHEET_BY_CUSTOMER = 'email_price_sheet_by_customer'
export const QUERY_KEY_EMAIL_TEMPLATE_DATA_BY_CUSTOMER_BY_EMPLOYEE = 'email_template_data_by_customer_by_employee'
export const EMPLOYEE_COLORS = ['#fcabae', '#fdd09c', '#fff000', '#a9eeae', '#95b9f0', '#d39ef0', '#d7b99c', '#cdcccc']
export const TRUCK_COLORS = ['#fcabae', '#fdd09c', '#fff000', '#a9eeae', '#95b9f0', '#d39ef0', '#d7b99c', '#cdcccc']
export const HOUSTON_BRANCH_ID = '5a624aeb08e910000fac79b3'
export const QUERY_KEY_SEND_EMAIL = 'send_email'
export const QUERY_KEY_AVAILABILITY_BY_BRANCH = 'availability_by_branch'
export const MUTATE_KEY_MOVE_ESTIMATE_BY_LOCATIONS = 'moveEstimateByLocations'
export const MUTATE_KEY_UPDATE_CUSTOMER_LEAD_NOTES = 'updateCustomerLeadNotes'
export const DEFAULT_TIMEZONE = 'America/Chicago'
export const CURRENT_TIMEZONE = 'America/Chicago'
export const MUTATE_KEY_GET_TROUBLE_LOCATION_BY_LOCATION = 'getTroubleLocationByLocation'
export const QUERY_KEY_AUTO_BOOKING = 'auto_booking'
export const QUERY_KEY_PRICING_RULES = 'pricing_rules'
export const MUTATE_KEY_CREATE_PRICING_RULE = 'createPricingRule'
export const MUTATE_KEY_UPDATE_PRICING_RULE = 'updatePricingRule'
export const MUTATE_KEY_DELETE_PRICING_RULE = 'deletePricingRule'
export const QUERY_KEY_ZIP_ZONES = 'zip_zones'
export const QUERY_KEY_BRANCH_SERVICE_ORIGINS = 'branch_service_origins'
export const MUTATE_KEY_ADD_ZIPCODE_TO_SERVICE_ORIGIN = 'addZipcodeToServiceOrigin'
export const MUTATE_KEY_REMOVE_ZIPCODE_FROM_SERVICE_ORIGIN = 'removeZipcodeFromServiceOrigin'
export const MUTATE_KEY_CREATE_ZIP_ZONE = 'createZipZone'
export const MUTATE_KEY_DELETE_ZIP_ZONE = 'deleteZipZone'
export const MUTATE_KEY_ADD_ZIPCODE_TO_ZONE = 'addZipcodeToZone'
export const MUTATE_KEY_REMOVE_ZIPCODE_FROM_ZONE = 'removeZipcodeFromZone'
export const MUTATE_KEY_UPDATE_ZONE_TRIP_FEE = 'updateZoneTripFee'
export const QUERY_KEY_CRON_JOBS = 'cron_jobs'
export const QUERY_KEY_CRON_JOB = 'cron_job'
export const QUERY_KEY_CRON_JOB_LOGS = 'cron_job_logs'
export const QUERY_KEY_CRON_JOB_RECENT_LOGS = 'cron_job_recent_logs'
export const MUTATE_KEY_RUN_CRON_JOB = 'runCronJob'
export const MUTATE_KEY_TOGGLE_CRON_JOB = 'toggleCronJob'
export const QUERY_KEY_EMAIL_DESIGN_TEMPLATES = 'email_design_templates'
export const QUERY_KEY_EMAIL_DESIGN_TEMPLATE = 'email_design_template'
export const MUTATE_KEY_CREATE_EMAIL_DESIGN_TEMPLATE = 'createEmailDesignTemplate'
export const MUTATE_KEY_UPDATE_EMAIL_DESIGN_TEMPLATE = 'updateEmailDesignTemplate'
export const MUTATE_KEY_DELETE_EMAIL_DESIGN_TEMPLATE = 'deleteEmailDesignTemplate'
export const MUTATE_KEY_SEND_TEST_EMAIL_DESIGN = 'sendTestEmailDesign'
export const QUERY_KEY_SALES_REVIEW_CUSTOMERS = 'sales_review_customers'
export const QUERY_KEY_RESOLVED_SALES_REVIEWS = 'resolved_sales_reviews'
export const QUERY_KEY_MARKETING_DASHBOARD_FTE = 'marketing_dashboard_fte'
export const QUERY_KEY_MARKETING_DASHBOARD_CAPACITY = 'marketing_dashboard_capacity'
export const QUERY_KEY_MARKETING_DASHBOARD_TRUCK_UTIL = 'marketing_dashboard_truck_util'
export const QUERY_KEY_SAFETY_CONFIG = 'safety-config'
export const QUERY_KEY_MARKETING_DASHBOARD_SETTINGS = 'marketing_dashboard_settings'
export const QUERY_KEY_ARRIVAL_CHECKLIST_DATA = 'arrivalChecklistData'
export const QUERY_KEY_DEPARTURE_CHECKLIST_DATA = 'departureChecklistData'
export const QUERY_KEY_WAIVERS_DATA = 'waiversData'
